export const meetupDate = '2026-06-17';
export const meetupStartTime = '10:00';
export const timeZone = 'CEST';
export const formName = 'europe-ai-digital-sovereignty-online-2026';
export const logoUrl = 'https://andersenlab.com/?utm_source=sovereignty_webinar&utm_medium=event';

export const phone = '+48 22 390 64 08';
export const email = 'contact@andersenlab.com';
